<template lang="pug">
#governance
  .container.custom_container_lg
    .row
      breadcrumb
  .container.custom_container_lg.i_mt_14.i_mt_md_10.text-center
    .desc
      p(v-html="companyManage.area01_Content01")
  .img.i_mt_8(
    v-if="companyManage",
    :style="{ backgroundImage: 'url(' + companyManage.area01_BannerPC + ')' }"
  )
  .container.custom_container_lg.i_mt_14.i_mt_md_10.text-center
    .desc.i_mt_6
      p(v-html="companyManage.area02_Content01")
  section.container.related_info.i_pt_10(
    v-if="companyManage.area02_FileList && companyManage.area02_FileList.length > 0"
  )
    .row
      .col-12.text-center
        h2.title {{ companyManage.area02_Title }}
    .row.i_mt_5
      .col-md-6.d-flex.i_mt_3.i_mt_sm_2.fade(
        v-for="(related, index) in companyManage.area02_FileList",
        :key="index",
        v-if="index < displayAmountSec2"
      )
        a.d-flex(:href="related.FileURL", target="_blank")
          svg-icon(iconClass="ic_download", className="icon")
          p.i_body_l.i_ml_2 {{ related.FileName }}
    .row.i_mt_8
      .collapse_btn(@click="expandSec2", :class="{ expand: isExpandSec2 }") {{ isExpandSec2 ? collapseText[1] + companyManage.area02_Title : collapseText[0] }}
  section.container.related_info.i_pt_10
    .row
      .col-12.text-center
        h2.title {{ companyManage.area03_Title }}
    .row.i_mt_5
      .col-md-6.d-flex.i_mt_3.i_mt_sm_2.fade(
        v-for="(related, index) in companyManage.area03_FileList",
        :key="index",
        v-if="index < displayAmountSec3"
      )
        a.d-flex(:href="related.FileURL", target="_blank")
          svg-icon(iconClass="ic_download", className="icon")
          p.i_body_l.i_ml_2 {{ related.FileName }}
    .row.i_mt_8
      .collapse_btn(@click="expandSec3", :class="{ expand: isExpandSec3 }") {{ isExpandSec3 ? collapseText[1] + companyManage.area03_Title : collapseText[0] }}
  media-img.golden_line_up.i_mt_14(:imgUrl="'golden_line_up'")

  .container
    .row.i_mt_10
      .col-12.text-center
        h2.title 誠信經營
  .img.i_mt_8(
    v-if="companyManage",
    :style="{ backgroundImage: 'url(' + companyManage.area04_BannerPC + ')' }"
  )
  .container
    .desc.i_mt_6
      p(v-html="companyManage.area04_Content")
  .container
    .row.i_mt_10
      .col-12.text-center
        h2.title 誠信經營政策
    .row.i_mt_10
      .col-12
        p(v-html="companyManage.area05_Content")
</template>

<script>
import MediaImg from "@/components/common/MediaImg";
import { getCompanyManage } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "Governance",
  metaInfo() {
    return {
      title: this.companyManage.SEO_Title,
      meta: [{ name: "description", content: this.companyManage.SEO_Description }],
    };
  },
  components: {
    "media-img": MediaImg,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      displayAmountSec2: 4,
      displayAmountSec3: 4,
      isExpandSec2: false,
      isExpandSec3: false,
      collapseText: ["展開看更多", "收起"],
      companyManage: {},
    };
  },
  created() {
    this.getCompanyManage();
  },
  methods: {
    expandSec2() {
      if (!this.isExpandSec2) {
        this.displayAmountSec2 = this.companyManage.area02_FileList.length;
      } else {
        this.displayAmountSec2 = 4;
      }

      this.isExpandSec2 = !this.isExpandSec2;
    },
    expandSec3() {
      if (!this.isExpandSec3) {
        this.displayAmountSec3 = this.companyManage.area03_FileList.length;
      } else {
        this.displayAmountSec3 = 4;
      }

      this.isExpandSec3 = !this.isExpandSec3;
    },
    getCompanyManage() {
      getCompanyManage().then((response) => {
        this.companyManage = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/about_us";
// @import "@/assets/style/about_us/profile";

.golden_line_up {
  height: 10px;
}

a {
  text-decoration: none;
}
.img {
  max-width: 1030px;
  @include size(100%, 430px);
  margin-left: auto;
  margin-right: auto;
}

h2.title {
  @include font(32px, $color_blue_ci, normal);
}

.related_info {
  max-width: 879px;

  .icon {
    @include size(30px, 30px);
    color: $color_blue_btn_ci;
  }

  p {
    color: $color_black_title;
  }
}

@media (max-width: 991px) {
  h2.title {
    font-size: 24px;
  }

  .img {
    @include size(567px, 305px);
  }

  .related_info {
    max-width: 600px;
  }
}

@media (max-width: 767px) {
  h2.title {
    font-size: 30px;
  }

  .img {
    @include size(100%, 54.16vw);
  }

  .related_info {
    max-width: 400px;
  }
}

@media (max-width: 575px) {
  .container {
    max-width: 440px;
  }

  h2.title {
    font-size: 5.2vw;
  }

  .related_info {
    .icon {
      @include size(5.2vw, 5.2vw);
    }

    p {
      font-size: 4.2vw;
      line-height: 7.35vw;
    }
  }
}
</style>
